import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useScanDetection from 'use-scan-detection';
import PostingsApi from '../../../API/shipment/postings-api';
import SuppliesApi from '../../../API/shipment/supplies-api';
import ShipmentWorkApi from '../../../API/shipment/work-api';
import UserApi from '../../../API/user/user-api';
import { addUser } from '../../../actions/user';
import excel from '../../../assets/media/icons/excel.png';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, H3 } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS, TYPE_BUTTONS, WAREHOUSES } from '../../../constans';
import { showSuccessNotify } from '../../../utils/Notiffication';
import PostingLine from './PostingLine';
import styles from './styles.module.scss';

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];;

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '220px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
];
const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

const NAVIGATE = {
  'FBO': ['Все товары', 'На упаковке', 'Упакованы', 'Ожидает упаковки'],
  'FBS': ['Все заказы', 'Упакованы', 'Ожидает упаковки'],
};

const FILTER = {
  'FBS': {
    0: 'all',
    1: 'packaged',
    2: 'awaiting_packaging',
  },
  'FBO': {
    0: 'packaging_all',
    1: 'packaging_packed_part',
    2: 'packaging_packed',
    3: 'packaging_awaiting',
  }
};

const MODES = ['FBO', 'FBS']

let abortController = new AbortController();

function PackagingPage() {

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const [mode, setMode] = useState(MODES[0])
  const [testBarcode, setTestBarcode] = useState('')

  const [namesUsers, setNamesUsers] = useState([]);

  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(20);
  const [date, setDate] = useState(moment(new Date()).format('MM-DD-YYYY'));
  const [period, setPeriod] = useState({ startDate: new Date(moment().subtract(14, 'day')), endDate: new Date(moment().add(5, 'day')) });
  const [market, setMarket] = useState(MARKETS_LIST[0]);
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });


  const [providers, setProviders] = useState([]);
  const [countPages, setCountPages] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);

  const [images, setImages] = useState([]);
  const [statistic, setStatistic] = useState({});
  const [countS, setCountS] = useState({
    count_scan: 0,
    count_packaging: 0,
    count_sort: 0,
    scan_pay: 0,
    packaging_pay: 0,
    sort_pay: 0,
  });
  const [map, setMap] = useState({});
  const [postings, setPostings] = useState([]);


  const onChangePage = (v) => { setPage(v) }
  const onChangeTab = (n) => { setTab(n) }

  const is_owner = user.role === 'owner' || user.role === 'admin';

  const addPosting = (posting, mapItem = {}) => {
    const newPostings = _.uniqBy([posting, ...postings], '_id')
    setPostings(newPostings.slice(0, show));
    setMap({ ...map, ...mapItem });
    const imgs = _.compact(Object.values(mapItem).map(card => card.images[0]))
    setImages(imgs);
  };

  const loadData = () => {
    PostingsApi.getPackagingPostings({
      data: {
        users: is_owner ? undefined : [user.name],
        tab: FILTER[mode][tab],
        limit: parseInt(show),
        sortType: 'packaging',
        providerId: is_owner ? provider.id : '',
        market: is_owner ? (market == 'Не выбрана' ? undefined : market.toLowerCase()) : undefined,
        period,
        skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      }
    })
      .then((res) => {
        const { postings, cardsMap = {}, all_count = {} } = res;
        const { all, awaiting_packaging, packaged } = all_count;

        setImages(cardsMap[_.first(postings)?.products[0]?.offer_id]?.images)
        setCountStock([all, packaged, awaiting_packaging]);
        setPostings(postings);
        setMap(cardsMap);
      })
      .catch();
  };

  const loadDataFbo = () => {
    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();

    SuppliesApi.getPackagingProductsFbo({
      data: {
        users: is_owner ? undefined : [user.name],
        tab: FILTER[mode][tab],
        page,
        period: { startDate: new Date(date), endDate: new Date(moment(date).add(1, 'days')) },
        limit: parseInt(show),
        sortType: 'packaging',
        providerId: is_owner ? provider.id : '',
        market: is_owner ? (market == 'Не выбрана' ? undefined : market.toLowerCase()) : undefined,
        skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      },
      signal: abortController.signal
    })
      .then((res) => {
        const { supplyItems, cardsMap = {}, tabs = {}, count, statistic } = res;

        setStatistic(statistic);
        setImages(cardsMap[_.first(supplyItems)?.offer_id]?.images)
        setCountStock(Object.values(tabs));
        setPostings(supplyItems);
        setMap(cardsMap);
        setCountPages(Math.ceil(count / show))
      })
      .catch();
  };

  useEffect(() => {
    if (mode === 'FBO') {
      loadDataFbo();
    } else if (mode === 'FBS') {
      loadData();
    }
  }, [tab, show, mode, provider.id, market, user.login, date, sklad, page]);

  // useEffect(() => {
  //   const p = allProviders.filter((item) => !item.hide);
  //   if (p.length > 0) {
  //     setProviders([{ name: 'Не выбран', id: null }, ...p]);
  //     changeProvider({ name: 'Не выбран', id: null });
  //   } else {
  //     changeProvider({ name: 'Не выбран', id: null });
  //   }
  // }, [allProviders]);

  const parseDetectQrPackager = (data) => {
    const detect = ':login:';
    const length = detect.length;
    const isLoginIndex = data.indexOf(detect);

    const isLogin = isLoginIndex !== -1;
    if (isLogin) {
      const [scanerId, barcode] = data.split(':');

      const username_pass = data.slice(isLoginIndex + length);
      const [username, password] = username_pass.split('/');

      console.log('login', username, password, scanerId);

      UserApi.login({ data: { login: username, password } })
        .then((res) => {
          dispatch(addUser(res.user));
          showSuccessNotify('Пользователь изменен');
          UserApi.setScannerId({ data: { login: username, scanerId } })
        })
        .catch((e) => console.log(e));
    }
    return isLogin;
  };

  useScanDetection({
    onComplete: async (data) => {
      const code = data.replaceAll('Shift', '');

      if (!parseDetectQrPackager(code)) {
        const [idPackger, barcode] = code.split(':');
        // const idPackger = code.slice(0, 1);
        // const barcode = code.slice(2);

        console.log(idPackger, barcode, barcode?.length);
        if (barcode?.length > 7) {
          console.log('sending...', idPackger, barcode);

          if (mode === 'FBO') {
            ShipmentWorkApi.packerScanFbo({ data: { postingBarcode: barcode, scanerId: idPackger } })
              .then(({ supplyItem, cardsMap, warning }) => {
                if (warning) {
                  // showWarningNotify('Заказ пикнут повторно');
                  addPosting(supplyItem, cardsMap);
                } else {
                  loadDataFbo()
                }
              })
          } else {
            await ShipmentWorkApi.packerScan({ data: { scanerId: idPackger, postingBarcode: barcode } })
              .then(({ user, posting, cardsMap, warning }) => {
                console.log
                if (warning) {
                  // showWarningNotify('Заказ пикнут повторно');
                  console.log('1121231231')
                  addPosting(posting, cardsMap);
                } else {
                  showSuccessNotify('Успешно');
                  setStatistic({
                    ...statistic,
                    [user.name]: {
                      ...statistic[user.name],
                      package: { ...statistic[user.name].sort, count: statistic[user.name]['package'].count + 1 },
                    },
                  });
                  addPosting(posting, cardsMap);
                }
              })
              .catch();
          }
        }
      }
    },
  });

  useEffect(() => {


    const loadStatistic = async () => {
      if (mode === 'FBS') {
        await ShipmentsApi.getUsersStatistic({ data: { users: namesUsers, date } })
          .then((r) => {
            setStatistic(r.statistic)
          })
      }

      const res = Object.values(statistic).reduce(
        ({ count_scan, count_packaging, count_sort, scan_pay, packaging_pay, sort_pay }, item) => {
          return {
            count_scan: count_scan + (item.pick?.count || 0),
            count_packaging: count_packaging + (item.package?.count || 0),
            count_sort: count_sort + (item.package?.sort || 0),

            scan_pay: scan_pay + (item.pick?.pay || 0),
            packaging_pay: packaging_pay + (item.package?.pay || 0),
            sort_pay: sort_pay + (item.sort?.pay || 0),
          };
        },
        { count_scan: 0, count_packaging: 0, count_sort: 0, scan_pay: 0, packaging_pay: 0, sort_pay: 0 },
      );
      setCountS(res);
    }

    loadStatistic()
  }, [namesUsers, date, user, statistic]);

  useEffect(() => {
    UserApi.getUsersByRole({ data: { role: 'packer' } })
      .then((r) => { setNamesUsers(r => r.map(u => u.names)); })
  }, []);

  const scan = () => { }

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <Content>
      <Row style={{ alignItems: 'flex-start' }}>
        <WhiteBlock style={{ width: 'fit-content' }}>
          <H3>Упаковка</H3>
          <Row
            style={{ margin: '10px 0 20px' }}
          >
            <Select
              style={{ margin: '8px 40px 0  0' }}
              label="Схема отгрузки"
              select={mode}
              big
              onSelect={(m) => {
                setMode(m)
              }}
              width={'130px'}
              list={MODES}
            />
            <DateInput
              label="Дата упаковки"
              className={styles.date_input}
              value={date}
              width={'200px'}
              onChange={(v) => setDate(new Date(v))}
            />
          </Row>
          <Row>
            <H1 style={{ fontSize: '60px', margin: '0' }}>{user.name}</H1>
            <div className={styles.count_packager}>
              {statistic[user.name]?.package?.count || 0}
              {statistic[user.name]?.pick?.count > 0 && (<span style={{ color: '#c7118f' }}>/ {statistic[user.name].pick.count} </span>)}
              {statistic[user.name]?.sort?.count > 0 && (<span style={{ color: 'rgb(201 132 15)' }}>/ {statistic[user.name].sort.count} </span>)}
            </div>

          </Row>
          {/* <Row>
            <Input
              value={testBarcode}
              onBlur={(v) => {
                setTestBarcode(v)
              }}
            />
            <Button
              type={TYPE_BUTTONS.BLUE}
              onClick={async () => {
                ShipmentWorkApi.packerScanFbo({ data: { postingBarcode: testBarcode, scanerId: 122 } })
                  .then(r =>
                    loadDataFbo()
                  )
              }}
            >
              Отправить
            </Button>
          </Row> */}
        </WhiteBlock>
        {is_owner && (
          <WhiteBlock style={{ width: '600px', marginLeft: '50px', alignSelf: 'normal' }}>
            <H3 style={{ marginBottom: '15px' }}>Статистика</H3>
            <div className={styles.count} style={{ width: '300px' }}>
              {(countS || {}).count_packaging} / <span style={{ color: '#c7118f' }}>{(countS || {}).count_scan} </span>{' '}
              <span style={{ color: 'rgb(201 132 15)' }}>/ {(countS || {}).count_sort} </span>
            </div>

            <div className={styles.payout} style={{ marginBottom: '10px', width: '500px' }}>
              {(countS || {}).packaging_pay}р. + <span style={{ color: '#0f8d1a' }}>{(countS || {}).scan_pay}р. </span>{' '}
              + <span style={{ color: 'rgb(19 171 129)' }}>{countS?.sort_pay}р. </span>={' '}
              <span style={{ color: '#0f8d1a' }}>
                {countS?.scan_pay + countS?.packaging_pay + countS?.sort_pay}р.
              </span>
            </div>
            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                PostingsApi.excelWorkers({
                  data: {
                    users: namesUsers,
                    period: { startDate: date, endDate: new Date().setTime(new Date(date).getTime() + 24 * 3600000) },
                  }
                })
              }
            >
              Скачать отчет <Icon src={excel} width={30} style={{ marginLeft: '10px' }} />
            </Button>
          </WhiteBlock>
        )}
        {!is_owner && images?.map((img) => (
          <Icon key={img} src={img} height={'260px'} style={{ marginLeft: '20px' }} />
        ))}
      </Row>

      <Row style={{ alignItems: 'flex-start' }}>
        <Column style={{ width: '1670px', marginRight: '20px' }}>
          <Column>
            {is_owner && (
              <WhiteBlock className={styles.search_block}>
                <Row className={styles.navigate_table}>
                  <NavTabs
                    open_tab={tab}
                    tabs={NAVIGATE[mode]}
                    isNum={true}
                    num={countStock}
                    style_tab={styles.style_tab}
                    onChange={onChangeTab}
                  />
                </Row>
                <Row spaceBetween={true} style={{ marginTop: '20px' }}>
                  <Row style={{ height: '40px' }}>
                    <Select
                      label="Показать на странице"
                      select={show}
                      list={['20', '50', '100', '150', '200', '500', '1000']}
                      onSelect={(v) => setShow(v)}
                      width="150px"
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      list={MARKETS_LIST}
                      select={MARKETS_LIST[0]}
                      label="Площадка"
                      onSelect={(v) => setMarket(v)}
                      width={'150px'}
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      label="Поставщик"
                      select={provider}
                      valueFn={(p) => p.name}
                      list={providers}
                      width="200px"
                      onSelect={(v) => changeProvider(v)}
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      list={SKLAD_LIST}
                      select={sklad}
                      label="Склад отгрузки"
                      onSelect={(v) => setSklad(v)}
                      width={'200px'}
                    />
                  </Row>
                  {mode === 'FBS' &&
                    <Row>
                      <Column style={{ marginRight: '10px' }}>
                        <InputLabel>Начало периода</InputLabel>
                        <Row style={{ width: '130px' }}>
                          <DateInput
                            value={period.startDate}
                            className={styles.calendar}
                            onChange={(v) => setPeriod({ ...period, startDate: new Date(v) })}
                          />
                        </Row>
                      </Column>
                      <Column style={{ marginRight: '10px' }}>
                        <InputLabel>Конец периода</InputLabel>
                        <Row style={{ width: '130px' }}>
                          <DateInput
                            value={period.endDate}
                            className={styles.calendar}
                            onChange={(v) => setPeriod({ ...period, endDate: new Date(v) })}
                          />
                        </Row>
                      </Column>
                    </Row>
                  }
                </Row>
              </WhiteBlock>
            )}

            {mode === 'FBS' ?
              <Table styles={styles.table}>
                <TableHeader whiteHeader>
                  <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
                  {is_owner && (
                    <HeaderTitle width={WIDTH_POSTING[12]} centerText>
                      Дата отгрузки
                    </HeaderTitle>
                  )}
                  <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>
                    Количество
                  </HeaderTitle>
                  {is_owner && (
                    <>
                      <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                        Статус упаковки
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>
                        Склад отгрзки
                      </HeaderTitle>
                    </>
                  )}
                  <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>
                    Сложность упаковки
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Cборщик / время сборки
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Упаковщик / время упаковки
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Сортировщик / время сортировки
                  </HeaderTitle>
                  {is_owner && (
                    <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                      Поставщик
                    </HeaderTitle>
                  )}
                </TableHeader>
                {postings.map((order) => {
                  return (
                    <PostingLine
                      isAdmin={isAdmin}
                      scan={scan} // выпилить потом
                      order={order}
                      map={map}
                      is_owner={is_owner}
                      key={order.posting_number}
                    />
                  );
                })}
              </Table>
              :
              <Table styles={styles.table}>
                <TableHeader whiteHeader>
                  {/* <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle> */}
                  {/* {is_owner && ( */}
                  {/* <HeaderTitle width={WIDTH_POSTING[12]} centerText> */}
                  {/* Дата отгрузки */}
                  {/* </HeaderTitle> */}
                  {/* )} */}
                  <HeaderTitle width={WIDTH_POSTING[12]} style={{ fontSize: '10px' }}>Площадка</HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
                  {/* <HeaderTitle width={WIDTH_POSTING[0]}>Время</HeaderTitle> */}
                  <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>
                    Количество
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>Количество в заказе</HeaderTitle>
                  {/* {is_owner && (
                    <>
                      <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                        Статус упаковки
                      </HeaderTitle>
                      <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>
                        Склад отгрзки
                      </HeaderTitle>
                    </>
                  )} */}
                  <HeaderTitle width={WIDTH_POSTING[3]} centerText={true}>
                    Сложность упаковки
                  </HeaderTitle>
                  {/* <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Cборщик / время сборки
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Упаковщик / время упаковки
                  </HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Сортировщик / время сортировки
                  </HeaderTitle>
                  {is_owner && (
                    <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                      Поставщик
                    </HeaderTitle>
                  )} */}
                  <HeaderTitle width={WIDTH_POSTING[0]} centerText>Упаковщик</HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[12]} centerText>Ушло времени</HeaderTitle>
                  <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}></HeaderTitle>

                </TableHeader>
                {postings.map((order) => {
                  return (
                    <PostingLine
                      mode={mode}
                      isAdmin={isAdmin}
                      scan={scan} // выпилить потом
                      order={order}
                      map={map}
                      is_owner={is_owner}
                      key={order._id}
                    />
                  );
                })}
              </Table>
            }
            {is_owner && <TablePagination num={countPages || 1} show={page} onChange={onChangePage} />}
          </Column>
        </Column>
        <Column style={{ marginRight: '20px' }}>
          {is_owner &&
            Object.entries(statistic).map(([name, stat], key) => (
              <WhiteBlock style={{ width: '330px' }} key={name}>
                <Row style={{ alignItems: 'center' }}>
                  <H3 style={{ fontSize: '20px', margin: '0', width: '200px' }}>
                    {key + 1}. {name}
                  </H3>
                  <div className={styles.count}>
                    {stat.package?.count || 0} /{' '}
                    <span style={{ color: '#c7118f' }}>{stat.pick?.count || 0} </span>
                    {mode === 'FBS' && <span style={{ color: 'rgb(201 132 15)' }}>/ {stat.sort?.count || 0} </span>}
                  </div>
                  <div className={styles.payout}>
                    {stat.package?.pay || 0}р. +{' '}
                    <span style={{ color: '#0f8d1a' }}>{stat.pick?.pay || 0}р.</span>
                    {mode === 'FBS' && <span style={{ color: 'rgb(19 171 129)' }}>{' '}+ {stat.sort?.pay || 0}р.</span>}
                    ={' '}
                    <span style={{ color: '#0f8d1a' }}>
                      {(stat.package?.pay || 0) + (stat.pick?.pay || 0) + (stat?.sort?.pay || 0)}р.
                    </span>
                  </div>
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() =>
                      PostingsApi.excelPackagersStatistic({
                        data: {
                          user: name,
                          periodWorker: {
                            startDateWorker: date,
                            endDateWorker: new Date().setTime(new Date(date).getTime() + 24 * 3600000),
                          },
                        }
                      })
                    }
                    style={{ marginLeft: '10px' }}
                  >
                    <Icon src={excel} width={30} />
                  </Button>
                </Row>
              </WhiteBlock>
            ))}
        </Column>
      </Row>
    </Content>
  );
}

export default PackagingPage;
